import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const deleteMembers = async (memberId) => {
  return await axios.delete(`members/${memberId}`)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default deleteMembers;